import { Box, SearchInput } from "@dealer-center/core-components";
import { useEffect, useState } from "react";
import type { RouteObject } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";

export const route = {
  path: "userPermissionsManager/:userIdInput?",
  element: <PagesUserPermissionsManagerUiDisplay />
} as RouteObject;

export function PagesUserPermissionsManagerUiDisplay() {
  const [userIdInput, setuserIdInput] = useState<string | undefined>(undefined);
  const navigate = useNavigate();
  const { userId } = useParams();
  useEffect(() => {
    setuserIdInput(userId);
  }, [userId]);

  return (
    <Box>
      <h1>User Permissions Manager</h1>
      <SearchInput
        inputValue={userIdInput}
        name={"userPermissionsManagerInput"}
        placeholder="Search By User ID"
        onClearCallback={() => {
          navigate("/userPermissionsManager");
          setuserIdInput(undefined);
        }}
        onInputChange={event => {
          setuserIdInput(event.target.value);
        }}
        onSearchClick={() => {
          setuserIdInput(userIdInput);
          navigate(`/userPermissionsManager/${userIdInput}`);
        }}
      />
    </Box>
  );
}

export default PagesUserPermissionsManagerUiDisplay;
